import { Field } from '@datx/core';
import { JsonApiModel } from '../core/jsonApi/jsonApiModel';
import { ConsumerData } from '../core/types';

export interface SequenceList {
  list: [][]
}

export class SequenceJsonModel extends JsonApiModel {
  public static override readonly type = 'sequences';

  @Field({ isIdentifier: true })
  public id!: string;

  @Field()
  public active!: boolean;

  @Field()
  public approval!: string;

  @Field()
  public changedBy!: string;

  @Field()
  public consumerData!: ConsumerData;

  @Field()
  public consumerId!: string;

  @Field()
  public copyRestricted!: boolean;

  @Field()
  public kind!: string;

  @Field()
  public name!: string;

  @Field()
  public sequence!: SequenceList;

  @Field()
  public sortName!: string;

  @Field()
  public subjectId!: string;

  @Field()
  public version!: number;
}
